<div class="groups">
  @for (group of taskGroups; track group.group) {
    @if (group.tasks.length > 0) {
      <div class="group">
        <div class="title">{{ group.group }}</div>
        @for (task of group?.tasks; track task.key; let index = $index) {
          <div class="task">
            <div class="status-wrap">
              <div class="status" [ngClass]="task.status">
                @if (task.status === 'inProgress' && (task.progress ?? 0) > 0) {
                  <div class="fill" [style.width.%]="task.progress"></div>
                  <span class="label">{{ task.progress }}%</span>
                }
                @else {
                  <span class="label">{{ task.status }}</span>
                }
              </div>
              @if (getProgressDetails(task); as progress) {
                <div class="progress-popover">
                  <div class="row">
                    <div class="title">Processed</div>
                    <div class="value">{{ formatAmount(progress.processed, progress.unit) }}</div>
                  </div>
                  <div class="row">
                    <div class="title">Total</div>
                    <div class="value">{{ formatAmount(progress.total, progress.unit) }}</div>
                  </div>
                  <div class="row">
                    <div class="title">Remaining</div>
                    <div class="value">{{ formatRemaining(progress.remainingTime) }}</div>
                  </div>
                </div>
              }
            </div>
            <div class="name">{{ task?.name || getTaskTitle(task?.type) }}</div>
            @if (task?.status === 'inProgress' && task?.timeStart) {
              <div class="time">{{ task.timeStart | timeFormat: now }}</div>
            }
            @else if (task?.timeStart && task?.timeEnd && task?.timeStart !== task?.timeEnd) {
              <div class="time">{{ task.timeStart | timeFormat: task.timeEnd }}</div>
            }
            <div class="button-icon" [matMenuTriggerFor]="taskMenu">
              <mat-icon svgIcon="dots" class="icon"></mat-icon>
            </div>
            <mat-menu #taskMenu="matMenu">
              <ng-template matMenuContent>
                <button mat-menu-item (click)="editTask(task, server)">Edit</button>
                <button mat-menu-item (click)="resetTasks(task, server)">Reset</button>
                <button mat-menu-item (click)="restartTask(task, server)">Restart</button>
                <button mat-menu-item (click)="restartTask(task, server, true)">Restart only this</button>
                <button mat-menu-item (click)="forceDoneTask(task, server)">Force Done</button>
              </ng-template>
            </mat-menu>
          </div>
        }
      </div>
    }
  }
</div>